export enum Breakpoint {
  Xs = 360,
  Sm = 600,
  Md = 876,
  Lg = 1024,
  Xl = 1280,
  Xxl = 1536,
  Xxxl = 1920
}
